module.exports = __webpack_public_path__ + "media/images/front/services/pilot-0ae06e8a5f426e74342259e1047c31ab.jpg";